/**
 * 影片網址工具：後台「預覽影片」欄位可能貼 YouTube 連結或直接的 mp4 檔。
 * <video> 標籤播不了 YouTube，需改用 iframe 內嵌，因此先在這裡判別。
 */

// 解析 YouTube 網址取得影片 ID（支援 watch?v= / youtu.be/ / shorts/ / embed/）；非 YouTube 回 null
export function youtubeIdOf(url) {
  if (!url) return null;
  const m = String(url).match(
    /(?:youtube\.com\/(?:watch\?(?:.*&)?v=|shorts\/|embed\/)|youtu\.be\/)([\w-]{6,})/
  );
  return m ? m[1] : null;
}

// YouTube 內嵌播放網址（靜音自動播放 + 循環，符合瀏覽器 autoplay 政策）
export function youtubeEmbedUrl(id) {
  const params = new URLSearchParams({
    autoplay: '1', mute: '1', loop: '1', playlist: id, rel: '0', playsinline: '1',
  });
  return `https://www.youtube.com/embed/${id}?${params}`;
}
